<app-header></app-header>
<app-sidebar></app-sidebar>
<app-right-sidebar></app-right-sidebar>
<div [dir]="direction">
  <router-outlet></router-outlet>
</div>
<app-ai-chat></app-ai-chat>
